import React from "react";

const BuildingOutlineIcon: () => JSX.Element = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 18.75H17.25M1.5 0.75H16.5M2.25 0.75V18.75M15.75 0.75V18.75M6 4.5H7.5M6 7.5H7.5M6 10.5H7.5M10.5 4.5H12M10.5 7.5H12M10.5 10.5H12M6 18.75V15.375C6 14.754 6.504 14.25 7.125 14.25H10.875C11.496 14.25 12 14.754 12 15.375V18.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BuildingOutlineIcon;
